/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeFormMessages.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Form Message Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Archetact ]
 *
 *  Created:    Saturday, August 27, 2022 - 09:05:11 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      08/27/2022  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2022 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const FORMMESSAGE_LIST_CONTAINER_LOADED = 'FORMMESSAGE_LIST_CONTAINER_LOADED';
export const FORMMESSAGE_LIST_CONTAINER_UNLOADED = 'FORMMESSAGE_LIST_CONTAINER_UNLOADED';
export const FORMMESSAGE_LIST_TABLE_LOADED = 'FORMMESSAGE_LIST_TABLE_LOADED';
export const FORMMESSAGE_LIST_TABLE_UNLOADED = 'FORMMESSAGE_LIST_TABLE_UNLOADED';

export const FORMMESSAGE_LIST_CHANGE_GROUP = 'FORMMESSAGE_LIST_CHANGE_GROUP';
export const FORMMESSAGE_SELECT_ROW = 'FORMMESSAGE_SELECT_ROW';

export const FORMMESSAGE_ADD = 'FORMMESSAGE_ADD';
export const FORMMESSAGE_EDIT = 'FORMMESSAGE_EDIT';
export const FORMMESSAGE_DELETE = 'FORMMESSAGE_DELETE';
export const FORMMESSAGE_OPEN_WARNING = 'FORMMESSAGE_OPEN_WARNING';
export const FORMMESSAGE_CLOSE_WARNING = 'FORMMESSAGE_CLOSE_WARNING';
export const FORMMESSAGE_DELETE_DISABLE = 'FORMMESSAGE_DELETE_DISABLE';
export const FORMMESSAGE_VIEW_CHILD_ITEMS = 'FORMMESSAGE_VIEW_CHILD_ITEMS';

export const FORMMESSAGE_EDIT_CONTAINER_LOADED = 'FORMMESSAGE_EDIT_CONTAINER_LOADED';
export const FORMMESSAGE_EDIT_CONTAINER_UNLOADED = 'FORMMESSAGE_EDIT_CONTAINER_UNLOADED';
export const FORMMESSAGE_EDIT_FORM_LOADED = 'FORMMESSAGE_EDIT_FORM_LOADED';
export const FORMMESSAGE_EDIT_FORM_UNLOADED = 'FORMMESSAGE_EDIT_FORM_UNLOADED';

export const FORMMESSAGE_SET_GROUP_SELECT = 'FORMMESSAGE_SET_GROUP_SELECT';
export const FORMMESSAGE_EDIT_DATA_LOAD = 'FORMMESSAGE_EDIT_DATA_LOAD';

export const FORMMESSAGE_EDIT_CONTAINER_SUBMIT = 'FORMMESSAGE_EDIT_CONTAINER_SUBMIT';
export const FORMMESSAGE_EDIT_CONTAINER_CANCEL = 'FORMMESSAGE_EDIT_CONTAINER_CANCEL';